/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";

// KD10 — KD57200 WHITE dzieci 223x300 mm
// Pozycje tekstów (style inline, w mm):
//   top   = górna krawędź pola tekstowego
//   left  = środek tekstu (textAlign center + translateX(-50%)) albo lewa krawędź (textAlign left)
//   right = prawa krawędź pola (textAlign right)
// maxWidthN = maks. szerokość tekstu w px — dłuższy tekst zmniejsza czcionkę.
// Uwaga: lineHeight w stylu InlineEdit nie działa (nadpisuje go `font: inherit`), zawsze wynosi 1.5.
export const Kd10: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("Pierwsze");
  const [text2, setText2] = useState<string>("wspomnienia");
  const [text3, setText3] = useState<string>("Nikoli");
  const [text4, setText4] = useState<string>("18.06.2015");
  const [text5, setText5] = useState<string>("godz. 19:50");
  const [text6, setText6] = useState<string>("3450 g");
  const [text7, setText7] = useState<string>("57 cm");
  const text1BasicSize = 82;
  const text2BasicSize = 88;
  const text3BasicSize = 95;
  const text4BasicSize = 40;
  const text5BasicSize = 30;
  const text6BasicSize = 33;
  const text7BasicSize = 37;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const [fontSizeText6, setFontSizeText6] = useState<number>(text6BasicSize);
  const [fontSizeText7, setFontSizeText7] = useState<number>(text7BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();

  const pdfWidth = "223mm"; // PDF width in mm
  const pdfHeight = "300mm"; // PDF height in mm
  const font1 = "StylishCalligraphy";
  const font2 = "AmaticSCBold";
  const maxWidth1 = 446;
  const maxWidth2 = 478;
  const maxWidth3 = 397;
  const maxWidth4 = 144;
  const maxWidth5 = 121;
  const maxWidth6 = 83;
  const maxWidth7 = 83;

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number,
    fontFamily: string,
    maxWidth: number,
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px ${fontFamily}`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  // Czekamy na załadowanie fontu, inaczej canvas mierzy tekst fontem zastępczym.
  const ensureFont = (fontFamily: string) =>
    document.fonts.load(`1em ${fontFamily}`);

  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText1(
        adjustFontSize(
          text1,
          fontSizeText1,
          text1BasicSize,
          14,
          font1,
          maxWidth1,
        ),
      ),
    );
  }, [text1]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText2(
        adjustFontSize(
          text2,
          fontSizeText2,
          text2BasicSize,
          14,
          font2,
          maxWidth2,
        ),
      ),
    );
  }, [text2]);
  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText3(
        adjustFontSize(
          text3,
          fontSizeText3,
          text3BasicSize,
          14,
          font1,
          maxWidth3,
        ),
      ),
    );
  }, [text3]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText4(
        adjustFontSize(
          text4,
          fontSizeText4,
          text4BasicSize,
          14,
          font2,
          maxWidth4,
        ),
      ),
    );
  }, [text4]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText5(
        adjustFontSize(
          text5,
          fontSizeText5,
          text5BasicSize,
          10,
          font2,
          maxWidth5,
        ),
      ),
    );
  }, [text5]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText6(
        adjustFontSize(
          text6,
          fontSizeText6,
          text6BasicSize,
          10,
          font2,
          maxWidth6,
        ),
      ),
    );
  }, [text6]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText7(
        adjustFontSize(
          text7,
          fontSizeText7,
          text7BasicSize,
          10,
          font2,
          maxWidth7,
        ),
      ),
    );
  }, [text7]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      null,
      false,
    );
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "#ffffff",
        padding: "60px",
        position: "relative",
      }}
    >
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div
        style={{
          position: "absolute",
          top: "10px",
          left: "0px",
          right: "0px",
          margin: "auto",
          color: "white",
          width: "150px",
          height: "50px",
        }}
      >
        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? "Zapisywanie..." : "Zapisz"}
        </Button>
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "StylishCalligraphy, AmaticSCBold",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        {/* Pierwsze */}
        <InlineEdit
          value={text1}
          setValue={setText1}
          style={{
            fontSize: `${fontSizeText1}px`,
            fontFamily: font1,
            color: "#898174",
            position: "absolute",
            top: "85.5mm",
            left: "110.8mm",
            width: `${maxWidth1 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* wspomnienia */}
        <InlineEdit
          value={text2}
          setValue={setText2}
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: font2,
            color: "#cdc3be",
            position: "absolute",
            top: "110mm",
            left: "112.6mm",
            width: `${maxWidth2 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "0.3px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* Nikoli */}
        <InlineEdit
          value={text3}
          setValue={setText3}
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: font1,
            color: "#898174",
            position: "absolute",
            top: "148.6mm",
            left: "109.3mm",
            width: `${maxWidth3 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "0.4px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 18.06.2015 */}
        <InlineEdit
          value={text4}
          setValue={setText4}
          style={{
            fontSize: `${fontSizeText4}px`,
            fontFamily: font2,
            color: "#898174",
            position: "absolute",
            top: "200.1mm",
            left: "101.6mm",
            width: `${maxWidth4 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* godz. 19:50 */}
        <InlineEdit
          value={text5}
          setValue={setText5}
          style={{
            fontSize: `${fontSizeText5}px`,
            fontFamily: font2,
            color: "#898174",
            position: "absolute",
            top: "230.3mm",
            left: "134.2mm",
            width: `${maxWidth5 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 3450 g */}
        <InlineEdit
          value={text6}
          setValue={setText6}
          style={{
            fontSize: `${fontSizeText6}px`,
            fontFamily: font2,
            color: "#898174",
            position: "absolute",
            top: "249.5mm",
            left: "92.5mm",
            width: `${maxWidth6 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 57 cm */}
        <InlineEdit
          value={text7}
          setValue={setText7}
          style={{
            fontSize: `${fontSizeText7}px`,
            fontFamily: font2,
            color: "#898174",
            position: "absolute",
            top: "252.3mm",
            left: "49.5mm",
            width: `${maxWidth7 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "0.2px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />

        <img
          src="/images/KD10.svg"
          alt=""
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: "0",
            left: "0",
            zIndex: "2",
          }}
        />
      </div>
    </div>
  );
};
